import { render, staticRenderFns } from "./ProjectInfoGeneral.vue?vue&type=template&id=6658ace7&scoped=true"
import script from "./ProjectInfoGeneral.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoGeneral.vue?vue&type=script&lang=ts"
import style0 from "./ProjectInfoGeneral.vue?vue&type=style&index=0&id=6658ace7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658ace7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6658ace7')) {
      api.createRecord('6658ace7', component.options)
    } else {
      api.reload('6658ace7', component.options)
    }
    module.hot.accept("./ProjectInfoGeneral.vue?vue&type=template&id=6658ace7&scoped=true", function () {
      api.rerender('6658ace7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectInfoGeneral.vue"
export default component.exports